import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {TitledBody} from '../../common/components/TitledBody'
import {Grid} from "@mui/material";
import {SectionedForm} from "../../common/components/SectionedForm";

import {SupervisorList} from "./supervisor";
import {useAccessHelpers} from "../../common/util/hooks";
import {useDirectorySection} from "./directory";

export const Businessreporting = () => {
    const { t } = useTranslation()
    const {hasWriteAccess} = useAccessHelpers()

    const supervisorSection = SupervisorList();
    const directorySection = useDirectorySection();
    const formSections = useMemo(() => [
        supervisorSection, directorySection
    ], [supervisorSection, directorySection])

    return (
        <TitledBody title={t('navigation.business-reporting')}>
            <Grid container>
                <Grid item xs={12} lg={10}>
                    <SectionedForm activeTab={0} formSections={formSections} readOnly={!hasWriteAccess}/>
                </Grid>
            </Grid>
        </TitledBody>
    )
}
